import {
  initI18n as baseInit,
  setLocale,
  t,
  type Language,
} from '@bn-games/i18n-core';
import { en } from './locales/en.js';
import { ru } from './locales/ru.js';

export { setLocale, t };

export async function initI18n(lang: Language): Promise<void> {
  await baseInit(lang, { en, ru });
}

/**
 * Lookup for keys assembled at runtime (narration, piece names). The typed
 * `t` only accepts literal keys; these are covered by the locale parity and
 * narration tests instead.
 */
export function translateDynamic(key: string, vars?: Readonly<Record<string, string>>): string {
  return (t as unknown as (k: string, o?: Readonly<Record<string, string>>) => string)(key, vars);
}
